import React from "react";
import { format } from "date-fns";

export default function UserEditDialogHeader({ id, registeredDate }) {
  const date = registeredDate
    ? format(new Date(registeredDate), "MMMM dd, yyyy")
    : "No date registered";

  return (
    <div className="container mt-4">
      <div className="d-flex my-2">
        <div className="col-6">
          <strong>Restless User</strong>
        </div>
        <div className="col-6 d-flex justify-content-end">
          {"Registered on " + date || "No registered date"}
        </div>
      </div>
    </div>
  );
}
